import React, { useContext } from 'react';
import BackButtonBar from '../BackButtonBar/index';
import { vehicleContext } from '../VehicleProvider';
import LocationBar from '../LocationBar/index';

const HeaderBackBar: React.FC = () => {
  const { vehicle, market, isTier3, loading } = useContext(vehicleContext);
  const isCanadian = market?.includes('ca') || false;
  if (!vehicle && !loading) return null;
  return (
    <>
      {!isTier3 && <BackButtonBar market={market ?? ''} />}
      <LocationBar isCanadian={isCanadian} isTier3={isTier3} vehicle={vehicle} />
    </>
  );
};

export default HeaderBackBar;
